import { render } from "./TheContainer.vue?vue&type=template&id=07b5462c&scoped=true"
import script from "./TheContainer.vue?vue&type=script&lang=js"
export * from "./TheContainer.vue?vue&type=script&lang=js"

import "./TheContainer.vue?vue&type=style&index=0&id=07b5462c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b5462c"]])

export default __exports__